// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TextSearchPattern } from "./text-search-pattern";
import { TextSearchPatternOrItemListType } from "../enums/text-search-pattern-or-item-list-type";

export class TextSearchPatternOrItemList {
	public SearchPattern: TextSearchPattern = new TextSearchPattern();
	public Type: TextSearchPatternOrItemListType = TextSearchPatternOrItemListType.TextSearchPattern;
	public Items: string[] = [];
}